import type { DesignConfig, TierConfig } from './types';

let tierCounter = 0;

/** Allocate an id that is unique within a session. */
export function newTierId(): string {
  tierCounter += 1;
  return `t${tierCounter}`;
}

export function blankTier(overrides: Partial<TierConfig> = {}): TierConfig {
  return {
    id: newTierId(),
    bucket: 'telemetry_rollup',
    window: '1h',
    aggregates: ['mean'],
    retention: '90d',
    createEmpty: false,
    ...overrides,
  };
}

/**
 * A realistic starting point: a 2 000-device fleet sampling every 10 seconds,
 * rolled up to minute, hour and day tiers with progressively longer retention.
 */
export function defaultConfig(): DesignConfig {
  return {
    source: {
      bucket: 'telemetry_raw',
      org: 'acme',
      measurement: 'sensor_reading',
      fields: ['temperature', 'humidity'],
      tagKeys: [
        { key: 'device_id', cardinality: 2000, retained: true },
        { key: 'site', cardinality: 12, retained: true },
        { key: 'firmware', cardinality: 8, retained: false },
      ],
      interval: '10s',
      retention: '7d',
    },
    tiers: [
      {
        id: newTierId(),
        bucket: 'telemetry_1m',
        window: '1m',
        aggregates: ['mean', 'min', 'max'],
        retention: '30d',
        createEmpty: false,
      },
      {
        id: newTierId(),
        bucket: 'telemetry_1h',
        window: '1h',
        aggregates: ['mean'],
        retention: '180d',
        createEmpty: false,
      },
      {
        id: newTierId(),
        bucket: 'telemetry_1d',
        window: '1d',
        aggregates: ['mean'],
        retention: '730d',
        createEmpty: false,
      },
    ],
    schedule: {
      every: '',
      offset: '30s',
      cron: '',
      lateTolerance: '1m',
    },
    assumptions: {
      bytesPerPoint: 16,
      horizonDays: 730,
    },
  };
}
